import axios, { AxiosRequestConfig } from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  ICreateVocabularyPayload,
  IUpdateVocabularyPayload,
  IDeleteVocabularyPayload,
  IFetchVocabulariesPayload,
} from './types'

const config: AxiosRequestConfig = {
  responseType: 'json'
}

export function fetchVocabularies(payload: IFetchVocabulariesPayload) {
  return axios.get(`/api/v1/vocabularies/`, { params: convertToSnakeCase(payload) })
}

export function createVocabulary(payload: ICreateVocabularyPayload) {
  return axios.post(`/api/v1/vocabularies/`, convertToSnakeCase(payload), config)
}

export function updateVocabulary(payload: IUpdateVocabularyPayload) {
  return axios.put(`/api/v1/vocabularies/${payload.id}`, convertToSnakeCase(payload), config)
}

export function deleteVocabulary(payload: IDeleteVocabularyPayload) {
  return axios.delete(`/api/v1/vocabularies/${payload.id}`, config)
}
